import Cookies from "js-cookie";

export const getGuideInvoiceFileUrl = (invoiceId: string) =>
    `${process.env.REACT_APP_BACKEND_URL}/guide-invoices/${invoiceId}/file`;

export const fetchGuideInvoiceBlob = async (invoiceId: string): Promise<Blob> => {
    const token = Cookies.get("accessToken");
    const res = await fetch(getGuideInvoiceFileUrl(invoiceId), {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) {
        throw new Error("Failed to download invoice");
    }

    return res.blob();
};

export const downloadGuideInvoiceFile = async (
    invoiceId: string,
    originalFileName?: string
): Promise<void> => {
    const blob = await fetchGuideInvoiceBlob(invoiceId);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = originalFileName || "invoice.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
